export default "__VITE_ASSET__w9DOA43n__"